module.exports = __webpack_public_path__ + "img/Icon-60.08fa703c.png";